import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { buildOptions } from "../utils";
import { uniq } from "lodash";
import moment from "moment";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from'../staffApp/eventTriggers'
import RefillFormModal from "./RefillFormModal";
import fetchResidentMedications from "./fetchResidentMedications";

class MedicationFormModal extends Component {
  state = {
    loading: false
  }

  constructor(props) {
    super(props);
    this.signatureCanvas = React.createRef();
  }

  componentDidUpdate() {
    if(!this.signaturePad && this.signatureCanvas.current) {
      this.signaturePad = new SignaturePad(this.signatureCanvas.current, {
        onEnd: this.handleSignatureUpdate.bind(this)
      });
    }

    if (!this.props.show) {
      this.signaturePad = null;
    }
  }

  addOrganizationIdToMedication(medication) {
    const { organizationId } = this.props;
    return {
      ...medication,
      organization_id: organizationId
    }
  }

  handleSignatureUpdate() {
    this.handleChange("signature", this.signaturePad.toDataURL());
  }

  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentMedications(medication) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          medications_attributes: [this.addOrganizationIdToMedication(medication)]
        }
      })
    });
  }

  refreshMedications() {
    const { organizationName, resident, updateMedications, fetch } = this.props;

    return fetchResidentMedications(fetch, organizationName, resident.id).then(
      (medications) => updateMedications(medications)
    );
  }

  deleteMedication() {
    const { closeModal, isStaffApp } = this.props;

    this.updateResidentMedications({
      id: this.props.medication.id,
      _destroy: true
    }).then(() => {
      return this.refreshMedications();
    }).then(() => {
      if (isStaffApp) {
        alert("Medication was successfully deleted.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  saveMedication() {
    const { medication, closeModal, isStaffApp } = this.props;
    this.setState({ loading: true });
    this.updateResidentMedications(this.addOrganizationIdToMedication(medication)).then(() => {
      return this.refreshMedications();
    }).then(() => {
      this.setState({ loading: false });
      if (isStaffApp) {
        alert("Changes were successfully saved.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  renderRemaining() {
    const { medication } = this.props
    if (medication.remaining_quantity) {
      const quantity = parseFloat(medication.remaining_quantity);

      if(quantity > 10) {
        return (
          <span className="text-success">{medication.remaining_quantity}</span>
        )
      } else if (quantity > 5) {
        return (
          <span className="text-warning">{medication.remaining_quantity}</span>
        );
      } else {
        return (
          <span className="text-danger">{medication.remaining_quantity}</span>
        )
      }
    }
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveMedicationFunction = (e) => {
    this.props.dispatch(this.saveMedication())
  }

  componentDidMount() {
    document.addEventListener('saveMedication', this.saveMedicationFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveMedication', this.saveMedicationFunction)
  }

  render() {
    const {
      name,
      started_at,
      dosage,
      quantity,
      category,
      frequency,
      md,
      pill_count,
      discontinued_at,
      notes,
      signature_url,
      total_quantity,
      created_at
    } = this.props.medication;
    const { isStaffApp, hasDelete } = this.props
    const categoryOptions = buildOptions(uniq([
      "AM", "Midday", "Evening", "PM", "PRN", "QAM", "QD", "BID", "TID", "QID", "QHS", category
    ]));
    const categoryValue = categoryOptions.find((option) => option.value === category);

    return (
      <div><RefillFormModal />  
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Medication</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body>
          <Form.Group controlId="medicationName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              value={name}
              onChange={(e) => {
                this.handleChange('name', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationStartedAt">
            <Form.Label>Started at</Form.Label>
            <DatePicker
              selected={started_at ? moment(started_at) : null}
              className="form-control"
              onChange={(date) => {
                this.handleChange(
                  'started_at',
                  date ? date.format("YYYY-MM-DD") : null
                )
              }} />
          </Form.Group>
          <Form.Group controlId="medicationDiscontinuedAt">
            <Form.Label>Discontinued at</Form.Label>
            <DatePicker
              selected={discontinued_at ? moment(discontinued_at) : null}
              className="form-control"
              onChange={(date) => {
                this.handleChange(
                  'discontinued_at',
                  date ? date.format("YYYY-MM-DD") : null
                )
              }} />
          </Form.Group>
          {
            (created_at ? (
              moment(created_at).isBefore("2019-06-18")) ? (
                <Form.Group controlId="medicationPillCount">
                  <Form.Label className="mb-0">Pill Count</Form.Label>
                  <Form.Label className="d-block text-secondary"><small>How many pills are remaining</small></Form.Label>
                  <Form.Control
                    type="number"
                    value={pill_count || ""}
                    onChange={(e) => {
                      this.handleChange('pill_count', e.target.value)
                    }} />
                </Form.Group>
              ) : (
                <Form.Group controlId="medicationPillCount">
                  <Form.Label className="mb-0">Pill Count</Form.Label>
                  <Form.Label className="d-block pt-2">{this.renderRemaining()}</Form.Label>
                  <Form.Label className="d-block text-secondary"><small>To refill, use refill button</small></Form.Label>
                  {isStaffApp && <Button
                    variant="outline-info"
                    onClick={() => {
                      const { medication } = this.props;
                      this.props.refillMedication(medication);
                    }}>
                    Refill
                  </Button>
                  }
                </Form.Group>
              )
              
              : (
                <Form.Group controlId="medicationPillCount">
                  <Form.Label>Pill Count</Form.Label>
                  <Form.Control
                    type="number"
                    value={total_quantity || ""}
                    onChange={(e) => {
                      this.handleChange('total_quantity', e.target.value)
                    }} />
                </Form.Group>
            ))
          } 
          <Form.Group controlId="medicationDosage">
            <Form.Label className="mb-0">Dosage</Form.Label>
            <Form.Label className="d-block text-secondary"><small>What dosage was prescribed? (ie 100 mg)</small></Form.Label>
            <Form.Control
              value={dosage}
              onChange={(e) => {
                this.handleChange('dosage', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationQuantity">
            <Form.Label className="mb-0">Quantity</Form.Label>
            <Form.Label className="d-block text-secondary"><small>How many pills should the client take each time? (ie 1)</small></Form.Label>
            <Form.Control
              type="number"
              value={quantity}
              onChange={(e) => {
                this.handleChange('quantity', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationCategory">
            <Form.Label>Category</Form.Label>
            <Creatable
              options={categoryOptions}
              value={categoryValue}
              onChange={(option) => {
                this.handleChange('category', option.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationFrequency">
            <Form.Label className="mb-0">Frequency</Form.Label>
            <Form.Label className="d-block text-secondary"><small>How many times a day should the client take the medication?</small></Form.Label>
            <Form.Control
              value={frequency}
              onChange={(e) => {
                this.handleChange('frequency', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationMd">
            <Form.Label className="mb-0">Md</Form.Label>
            <Form.Label className="d-block text-secondary"><small>Prescribing Physician</small></Form.Label>
            <Form.Control
              value={md}
              onChange={(e) => {
                this.handleChange('md', e.target.value)
              }} />
          </Form.Group>
          <Form.Group controlId="medicationNotes">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              value={notes}
              onChange={(e) => {
                this.handleChange('notes', e.target.value)
              }} />
          </Form.Group>
          {
            this.props.action === "new" &&
            <Form.Group controlId="medicationSignature">
              <Form.Label>Signature</Form.Label>
              <div>
                <canvas
                  ref={this.signatureCanvas}
                  style={{ border: "1px solid #CCC" }} />
              </div>
            </Form.Group>
          }
          {
            this.props.action === "edit" &&
            signature_url !== "/signatures/original/missing.png" &&
            <img src={signature_url} style={{ border: "1px solid #ccc" }} />
          }
        </Modal.Body>
        {
          !isStaffApp ?
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => this.deleteMedication()}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              disabled={this.state.loading}
              onClick={() => this.saveMedication()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <>
            {
              this.props.action == 'edit' && hasDelete &&
              <div className="p-4">
                <Button variant="outline-danger w-100"
                onClick={() => this.deleteMedication()}>Delete</Button>
              </div>
            }
          </>
        }
      </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.medicationModal.show,
    medication: state.ui.medicationModal.medication,
    action: state.ui.medicationModal.action,
    organizationName: state.organization.name,
    organizationId: state.organization.id,
    resident: state.resident,
    resident_tabs: state.config.resident_tabs,
    isStaffApp: state.config.isStaffApp,
    config: state.config,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'meds'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit'),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "medication" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "medication", name, value }
      });
    },
    updateMedications: (medications) => {
      dispatch({
        type: "UPDATE_MEDICATIONS",
        payload: { medications }
      });
    },
    createMedication: (medication) => {
      dispatch({
        type: "CREATE_MEDICATION",
        payload: { medication }
      });
    },
    deleteMedication: (medication) => {
      dispatch({
        type: "DELETE_MEDICATION",
        payload: { medication }
      })
    },
    refillMedication: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: {
          resourceName: "refill",
          resource
        }
      })
    },
    dispatch: (func) => dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(MedicationFormModal));
